import apiService from '../../../services/api-client';
import { GetNotificationsResponse } from '../interfaces/get-notifications';

export const notificationApiService = {
  async getAllNotifications(page: number) {
    const { data } = await apiService().get<GetNotificationsResponse>(
      `notifications/all`,
      {
        params: { page },
      }
    );
    return data;
  },
  async getUnreadNotifications() {
    const { data } = await apiService().get<GetNotificationsResponse>(
      `notifications/unread`,
    );
    return data;
  },
  async postReadNotification(id: string, type: string) {
    const { data } = await apiService().post<GetNotificationsResponse>(
      `notifications/${type}/${id}/read`,
    );
    return data;
  },
  async postReadAllNotification() {
    const { data } = await apiService().post<GetNotificationsResponse>(
      `notifications/read/all`,
    );
    return data;
  },
};
